import Model from "~/models/_Model";
import Student from "~/models/eschoolplus/registration/Student";

export default class Schedule extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "activities";
  }

  relations() {
    return {
      student: Student,
    };
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
  get display_course() {
    return `${this.COURSE.trim()}-${this.COURSE_SECTION}: ${this.DESCRIPTION}`;
  }

  get display_primary_teacher_name() {
    return this.primary_staff
      ? this.primary_staff.display_name
      : this.PRIMARY_STAFF_ID.trim();
  }
}
